export enum BuildingChartView {
  Building = 1,
  Floor = 2,
}
